import React, {Component} from 'react'
import {Button, Tooltip} from 'antd'
import AddPartnerModal from './AddPartnerModal'
import {canManagePartner, getNoPermissionMessage} from '../../helpers/partnerPermission'

class AddPartner extends Component {
    state = {
        isOpen: false,
    }

    _showModal = () => {
        if (!canManagePartner()) return

        this.setState({
            isOpen: true,
        })
    }

    _closeModal = () => {
        this.setState({
            isOpen: false,
        })
    }

    render() {
        const { reset } = { ...this.props }
        const { isOpen } = this.state
        const canManage = canManagePartner()

        return (
            <div className="AddPartner">
                {canManage ? (
                    <Button type="primary" onClick={this._showModal}>
                        Tạo đối tác
                    </Button>
                ) : (
                    // Nút disabled không bắt sự kiện chuột -> bọc span để tooltip hiện được
                    <Tooltip title={getNoPermissionMessage('tạo')}>
                        <span className="d-inline-block" style={{ cursor: 'not-allowed' }}>
                            <Button type="primary" disabled style={{ pointerEvents: 'none' }}>
                                Tạo đối tác
                            </Button>
                        </span>
                    </Tooltip>
                )}
                <AddPartnerModal isOpen={isOpen} onClose={this._closeModal} reset={reset} />
            </div>
        )
    }
}

export default AddPartner